export const headerDialogs = {
    HOME: "home",
    USER: "user",
    SETTINGS: "settings",
    NOTIFICATIONS: "notifications",
    HELP: "help"
};

export const headerIcons = {
    HOME: "uic:apps",
    USER: "uic:user",
    SETTINGS: "uic:settings",
    NOTIFICATIONS: "uic:notifications",
    HELP: "uic:help"
};
